import {
  Navigate,
  Route,
  Routes as RouterRoutes,
  useLocation,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import AuthRoute from "../../components/AuthRoute";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";
import { NavBar } from "../../components/ui";
import { Portal } from "../../util";
import PrimaryNav from "./components/PrimaryNav";
import routes from "./routes";

const RedirectToLocations = () => {
  const location = useLocation();
  return (
    <Navigate replace to={{ pathname: "locations", search: location.search }} />
  );
};

const Body = props => (
  <Sentry.ErrorBoundary
    fallback={createModuleErrorBoundary("sites")}
    beforeCapture={scope => {
      scope.setTag("module", "sites");
    }}
  >
    <RouterRoutes>
      {routes.map(item => (
        <Route
          key={item.href}
          path={item.href}
          element={
            <AuthRoute permissions={item.permissions}>
              <item.element {...props} />
            </AuthRoute>
          }
        />
      ))}
      <Route path="*" element={<RedirectToLocations />} />
    </RouterRoutes>
  </Sentry.ErrorBoundary>
);

const Sites = props => (
  <div className="relative min-h-full w-full">
    <Portal id="sidebar">
      <NavBar navigation={routes} open={props?.open} />
    </Portal>
    <PrimaryNav />
    <Body {...props} />
  </div>
);

export default Sites;
